window.MS = window.MS || {};

export const breakpoint = () => {
  if (window.innerWidth < 768) {
    return 'mobile';
  } else if (window.innerWidth < 1280) {
    return 'tablet';
  }
  return 'desktop';
};

export const debounce = (func, wait, immediate) => {
  let timeout;

  return function () {
    const context = this,
      args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}

export const getSiblings = elem => {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;

  for ( ; sibling; sibling = sibling.nextSibling )
     if ( sibling.nodeType == 1 && sibling != elem )
        siblings.push( sibling );
  return siblings;
}

export const scrollObserver = () => {
  let currPos = document.body.getBoundingClientRect().top;
  let dir = 'down';

  // initial set
  window.MS.scrollObject = {
    x: 0,
    y: 0,
    verticalDirection: dir,
  }

  return window.addEventListener('scroll', () => {
    dir = document.body.getBoundingClientRect().top > currPos ? 'up' : 'down'
    currPos = document.body.getBoundingClientRect().top;

    window.MS.scrollObject = {
      x: window.pageXOffset || 0,
      y: window.pageYOffset || 0,
      verticalDirection: dir,
    }
  });
}

// Element matches a selector
export const matches = (element, selector) => {
  const prototype = { Element };

  function match() {
    return Array.from(document.querySelectorAll(selector)).includes(this);
  }

  const method =
    prototype.matches ||
    prototype.webkitMatchesSelector ||
    prototype.mozMatchesSelector ||
    prototype.msMatchesSelector ||
    match;

  return method.call(element, selector);
}

// Trigger event
export const trigger = (element, type) => {
  if (!element || !type) {
      return;
  }

  // Create and dispatch the event
  const event = new Event(type, { bubbles: true });

  // Dispatch the event
  element.dispatchEvent(event);
}

// Get the number of decimal places
export const getDecimalPlaces = (value) => {
  const match = `${value}`.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

  if (!match) {
    return 0;
  }

  return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
}

// Round to the nearest step
export const round = (number, step) => {
  if (step < 1) {
    const places = getDecimalPlaces(step);
    return parseFloat(number.toFixed(places));
  }
  return Math.round(number / step) * step;
}

// basically unwraps an element
export const unwrap = (node) => (node.replaceWith(...node.childNodes));

// Smooth scroll fix for Safari.
export const forceSmoothScrollTo = (scrollToValue, duration = 500) => {
  const start = window.pageYOffset;
  const change = scrollToValue - start;
  const startDate = Number(new Date());

  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const animateScroll = () => {
    const currentDate = Number(new Date());
    const currentTime = currentDate - startDate;

    window.scrollTo(0, parseInt(easeInOutQuad(currentTime, start, change, duration)));

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    }
  };

  animateScroll();
};

export const throttleRaf = (cb) => {
  let running = false;
  return () => {
    if (running) return;
    running = true;
    window.requestAnimationFrame(() => {
      cb();
      running = false;
    })
  }
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/util/helpers.js